import React, { useState } from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";
import PlaydateInviteFullDetails from "../PlaydateInviteFullDetails";
import { PlaydateInvite } from "../../../gql/types";
import downArrowIcon from '../../../assets/icons/downArrow.svg';
import upArrowIcon from '../../../assets/icons/upArrow.svg';
import PlaydateInviteResponseList from "../PlaydateInviteResponseList";

export const renderCollapsibleSection = ({
    title,
    isOpen,
    onToggle,
    content,
}: {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    content: React.ReactNode;
}) => (
    <>
        <div className={`${styles.collapsibleSectionHeader} ${isOpen ? styles.noBorder : styles.borderBottom}`} onClick={onToggle}>
            <div className={styles.collapsibleSectionTitleContainer}>
                <span className={styles.collapsibleSectionTitle}>{title}</span>
            </div>
            <div className={styles.chevronContainer}>
                <img
                    src={isOpen ? upArrowIcon : downArrowIcon}
                    alt={isOpen ? "Collapse section" : "Expand section"}
                    className={styles.chevronIcon}
                />
            </div>
        </div>
        {isOpen && <div className={styles.collapsibleSectionContainer}>{content}</div>
        }
    </>
);

type PlaydateInviteOrganizerInPlanningViewProps = {
    invite: PlaydateInvite;
    onBack: () => void;
    onFinalize: () => void;
    onModify: () => void;
    onDelete: () => void;
    baseZIndex?: number;
};

const PlaydateInviteOrganizerInPlanningView: React.FC<PlaydateInviteOrganizerInPlanningViewProps> = ({
    invite,
    onBack,
    onFinalize,
    onModify,
    onDelete,
    baseZIndex,
}) => {
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);
    const [isGuestListOpen, setIsGuestListOpen] = useState(true);

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Playdate Details"
            infoText="See who's joining you on your invite!"
            topIcon="happy"
            useSectionDivider={true}
        >
            {renderCollapsibleSection({
                title: "Guests:",
                isOpen: isGuestListOpen,
                onToggle: () => setIsGuestListOpen(prev => !prev),
                content: <PlaydateInviteResponseList inviteResponses={invite.responses ?? []} />,
            })}

            {
                renderCollapsibleSection({
                    title: "Playdate Details:",
                    isOpen: isDetailsOpen,
                    onToggle: () => setIsDetailsOpen(prev => !prev),
                    content: <PlaydateInviteFullDetails invite={invite} />,
                })}

            <div className={styles.buttonBuffer} />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={() => onFinalize()}
                    isLongText={true}
                >
                    Finalize Date and Time
                </ActionButton>
                <ActionButton
                    onClick={() => onModify()}
                    colorPattern="Transparent"
                    isLongText={true}
                >
                    Modify Invite Details
                </ActionButton>
                <UnderlineButton onClick={onDelete}>
                    Cancel Invite
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteOrganizerInPlanningView;
